import { render, staticRenderFns } from "./RelatedAgents.vue?vue&type=template&id=5f1a4a55&"
import script from "./RelatedAgents.vue?vue&type=script&lang=js&"
export * from "./RelatedAgents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports